module.exports = __webpack_public_path__ + "static/media/second-card.1246e92a.png";